import { Component, Inject, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SopoAlertService } from '../../../sopo-alert/sopo-alert.service';
import { ConfirmInputComponent } from '../confirm-input/confirm-input.component';

@Component({
    selector: 'app-string-input',
    templateUrl: './string-input.component.html',
    styleUrls: ['./string-input.component.scss'],
    standalone: false
})
export class StringInputComponent implements OnInit {

    input: string;
    @ViewChild('textInput', { static: true }) textInput: ElementRef;

    title: string;
    body: string;
    cancelText: string;
    okText: string;
    placeholder: string;
    numbersOnly: boolean;
    cancelReturn: boolean;
    maxlength: number;
    inputType = 'text';

    constructor(
        private dialogRef: MatDialogRef < ConfirmInputComponent > ,
        private alertService: SopoAlertService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.title = data.title;
        this.body = data.body;
        this.cancelText = data.cancelText;
        this.okText = data.okText;
        this.placeholder = data.placeholder;
        this.numbersOnly = data.numbersOnly;
        this.maxlength = data.maxlength ? data.maxlength: 100;
        if (data.cancelReturn) {
            this.cancelReturn = data.cancelReturn;
        }
        if (data.inputType) this.inputType = data.inputType;
    }

    ngOnInit() {
        this.textInput.nativeElement.focus();
    }

    getPattern() {
        if (this.numbersOnly) {
            return '[0-9]*';
        } else {
            return '[A-Za-z]';
        }
    }

    onUpdate(event) {
        if (this.maxlength) {
            const value = this.input.substring(0, this.maxlength);
            if (this.input.length >= this.maxlength) {
                this.input = value;
            }
        }
    }


    confirm() {
        if (this.input === undefined || this.input === '' || this.input.trim() === '') {
            this.alertService.alert({
                header: 'Invalid input',
                message: 'Input can not be empty.'
            })
        } else this.dialogRef.close({ value: this.input });
    }

    cancel() {
        this.dialogRef.close({ value: undefined});
    }
}
